import { TenderFilter } from '../../../../shared/types/tender';

export const initialValues: TenderFilter = {
    bidder: '',
    startCreatedAt: '',
    endCreatedAt: '',
    statusProcess: '',
};
